export default __webpack_public_path__ + "static/media/img-0236-australia-full-face.d01de579.png";